export interface AirportMessageAdd {
    airport: string;
    messageTypeId: string;
    messageContent: string;
    validFrom: Date;
    validUntil: Date;
}